<template>
  <b-container class="p-3">
    <b-row>
      <b-col>
        <h3>Notification</h3>
      </b-col>
    </b-row>

    <b-row>
      <!-- table -->
      <b-table
        hover
        show-empty
        stacked="md"
        thead-class="hidden_header"

        :items="notifications"
        :fields="notifications_column"

        :current-page="currentPage"
        :per-page="perPage"

        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <!-- slot -->
        <template v-slot:cell(actions)="row">
          <b-button size="sm" variant="danger" @click="openDeleteConfirm(row.item._id)">
            <font-awesome-icon icon="times" /> Mark as Read
          </b-button>
        </template>
      </b-table>
    </b-row>

    <b-row align-h="end">
      <b-col cols="2">
        <b-input-group size="sm" append="item per page">
          <b-form-select
            v-model="perPage"
            :options="pageOptions"
          >
          </b-form-select>
        </b-input-group>
      </b-col>

      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="end"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// external dependencies

// custom component

// api call
import UserNotificationAPI from '@/api/UserNotificationAPI'

export default {
  name: 'Notification',
  props: ['user'],
  data () {
    return {
      // data table
      notifications: [],
      notifications_column: [
        { key: 'content', label: '', thStyle: { display: 'none' } },
        { key: 'actions', label: '', class: 'text-center', thStyle: { display: 'none' } }
      ],

      // pagination
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50],

      // sorting
      sortBy: 'content',
      sortDesc: false,
      sortDirection: 'asc'
    }
  },
  mounted: function () {
    this.getCSNotification()
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    getCSNotification: async function () {
      const response = await UserNotificationAPI.getCSNotification(this.user._id)

      this.notifications = response.data.notification
      this.totalRows = this.notifications.length
    }
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Notification/Notification.vue